import { createBrowserHistory } from 'history';

export const routeHistory = createBrowserHistory();
